export enum Scenes {
  START_MENU = 'START_MENU',
  GAME = 'GAME',
  GAME_OVER = 'GAME_OVER',
  EXIT_GAME = 'EXIT_GAME',
  END_GAME = 'END_GAME',
  SCORE = 'SCORE',
  LOADING = 'LOADING',
  PAUSE_GAME = 'PAUSE_MENU',
}
